import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/type-scale.css";

// After a new build is published, an open tab may request page chunks that no
// longer exist. Reload once to pick up the fresh build instead of a blank screen.
const RELOAD_KEY = "chunk_reload_at";
const recoverFromStaleChunk = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 10_000) return; // avoid reload loops
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};
// Do not call preventDefault here: that makes the failed import resolve to
// `undefined`, and React.lazy then crashes reading `.default`.
window.addEventListener("vite:preloadError", () => {
  recoverFromStaleChunk();
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = String((e.reason as Error)?.message ?? e.reason ?? "");
  if (/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg)) {
    recoverFromStaleChunk();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
